// Keep caregiver controls usable with touch and a visible hardware-keyboard focus.
export const caregiverAccessibilitySx = {
    '& .MuiIconButton-root, & .MuiButton-root, & .MuiToggleButton-root': { minWidth: 48, minHeight: 48 },
    '& .MuiMenuItem-root, & .MuiCheckbox-root, & .MuiRadio-root': { minHeight: 48 },
    '& .MuiButtonBase-root:focus-visible': { outline: '2px solid currentColor', outlineOffset: 2 }
};
